import "./App.css";
import BookContainer from "./components/BookContainer";
import BookForm from "./components/BookForm";
import Navbar from "./components/Navbar";

function App() {
  return (
    <div className="App">
      <Navbar />
      <main className="py-12 2xl:px-6">
        <div className="container grid xl:grid-cols-[auto_350px] 2xl:grid-cols-[auto_400px] gap-4 2xl:gap-8">
          <BookContainer />
          <BookForm />
        </div>
      </main>
    </div>
  );
}

export default App;
